import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPipExit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-398.22 -348.44 2844.44 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M256 0H1024V512H256ZM1280 512H1792V1280H1024V1024H1120Q1186 1024 1233.0 977.0Q1280 930 1280 864ZM2048 1376V416Q2048 350 2001.0 303.0Q1954 256 1888 256H1280V-96Q1280 -162 1233.0 -209.0Q1186 -256 1120 -256H160Q94 -256 47.0 -209.0Q0 -162 0 -96V864Q0 930 47.0 977.0Q94 1024 160 1024H768V1376Q768 1442 815.0 1489.0Q862 1536 928 1536H1888Q1954 1536 2001.0 1489.0Q2048 1442 2048 1376Z"
	})
});
export default SvgPipExit;
